<template lang="pug">
.group.px-5
  v-row
    v-col
      h2.primary--text {{ $t('Group.generalInfo') }}
  template(v-if="isGroupParty() || isGroupTask()")
    v-row
      v-col(cols="4")
          v-text-field(
            :value= "instance.name",
            @input="$store.commit(setInstancePathAction, { path: path + '.name', value: $event })",
            :label="$t('GroupParty.name')",
            :error-messages="errors['group.name']",
          )
      v-col(cols="8")
        v-text-field(
          :value="instance.description",
          @input="$store.commit(setInstancePathAction, { path: path + '.description', value: $event })"
          :label="$t('GroupParty.description')",
          :error-messages="errors['group.description']",
        )
    v-row
      v-col(cols="4")
        app-datetime-picker(
          :value="instance.createdAt",
          disabled,
          :label="$t('GroupParty.createdAt')",
        )
      v-col(cols="4")
        app-datetime-picker(
          :value="instance.modifiedAt",
          disabled,
          :label="$t('GroupParty.modifiedAt')",
        )
      v-col(cols="4")
        v-text-field(
          :value="instance.user.fullName",
          disabled,
          :label="$t('GroupParty.userFullName')",
        )
  template(v-else)
    v-row
      v-col(cols="4")
        v-text-field(
          name="Name",
          :label="$t('Group.name')",
          :value="instance.name",
          @change="fixName"
          :error-messages="errors['group.name']",)
      v-col(cols="4")
        v-text-field(
          name="Description",
          :label="$t('Group.description')",
          v-model="instance.description",
          :error-messages="errors['group.description']")
      v-col(cols="4")
        v-autocomplete(
          name="Entity",
          :label="$t('Group.entity')",
          v-model="instance.entity",
          :items="entities",
          :error-messages="errors['group.entity']")
</template>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'

export default {
  name: 'group-add',
  mixins: [EntityMixin],
  props: ['path', 'entity'],
  data: function () {
    return {
      loading: true,
      loads: [
        'extraFields',
        'groupParties.Party',
        'groupTasks.Task',
        'user'
      ],
      entities: ENV.ENTITIES['Group']['fields']['entity']['options']
    }
  },
  methods: {
    // TODO: move to a helper function.
    fixName (name = '') {
      let oldName = this.instance.name
      this.instance.name = name.replace(/\s/g, '_')
      for (var i = 0; i < this.instance.extraFields.length; i++) {
        var reg = new RegExp(oldName, "g");
        this.instance.extraFields[i]._Rules = this.instance.extraFields[i]._Rules.replace(reg, name)
        this.instance.entityState = 3
        this.instance.extraFields[i].entityState = 3
      }
    },
    async load () {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${'Group'}/${this.uid}`, true, ...this.loads)
          let _instance = (await axios.get(endpoint, {
            _Entity: 'Group',
            uid: this.uid
          })).data
          this.instance = _instance;
          this.instance.entityState = 3
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        if(this.isGroupParty()){
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.entity', value: 'Party' });
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.type', value: 'GroupParty' });
        } else if(this.isGroupTask()){
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.entity', value: 'Task' });
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.type', value: 'GroupTask' });
        } else {
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.type', value: 'ExtraField' });
        }
        this.loading = false;
      }
    },
    isGroupParty() {
      if(this.$route.name.includes('GroupParty'))
        return true;
      return false;
    },
    isGroupTask() {
      if(this.$route.name.includes('GroupTask'))
        return true;
      return false;
    }
  },
  computed: {
    uid() {
      return this.$route.params.item
    },
    errors(){
     return this.$store.state.errors;
    }
  },
  async created () {
    this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.user', value: this.$store.state.user.user });
  },
  async mounted () {
    await this.load()
  },
}
</script>
